var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "reviews" },
    [
      _c(
        "div",
        { staticClass: "grid" },
        _vm._l(_vm.computedObj, function (review, index) {
          return _c(
            "div",
            { key: `review-item-${index}`, staticClass: "grid-item" },
            [
              _c(
                "div",
                { staticClass: "review-item" },
                [
                  _c("div", { staticClass: "review-item-element" }, [
                    _c("h4", [_vm._v(" " + _vm._s(review.title))]),
                  ]),
                  _vm._v(" "),
                  _vm.hasSubtitle(review)
                    ? [
                        _c("div", { staticClass: "review-item-element" }, [
                          _c("h5", [_vm._v(" " + _vm._s(review.subtitle))]),
                        ]),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "review-item-element" },
                    [
                      review.review
                        ? _c("read-more", {
                            staticClass: "item-description",
                            attrs: { text: review.review, "max-chars": 140 },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.hasRating(review)
                    ? [
                        _c("div", { staticClass: "review-item-element" }, [
                          _vm._v(
                            "\n          Rating: " +
                              _vm._s(review.points) +
                              "\n        "
                          ),
                        ]),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.hasLimit
        ? [
            _c(
              "div",
              { staticClass: "show-more" },
              [
                _c("HighlightButton", {
                  attrs: {
                    "button-type": "rounded",
                    "button-style": "outline",
                    "button-size": "small",
                    title: "Show More",
                  },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.showMore()
                    },
                  },
                }),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }